export default __webpack_public_path__ + "static/media/arkguide_06.94ecfcd4.gif";